import React from 'react';
import { Link } from 'react-router-dom';

// Slim, on-brand "demo mode" ribbon. Deep brand navy + amber accent so it reads
// as an intentional system bar that complements the branded heroes below it.
const DemoBanner = () => (
  <div className="w-full bg-brand-950 text-white border-b border-white/10">
    <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-center text-xs sm:text-[13px]">
      <span className="inline-flex items-center gap-2 font-semibold tracking-wide">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-60 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
        </span>
        Interactive Demo
      </span>
      <span className="hidden sm:inline text-brand-200">Sample data for preview, no real tickets are sold.</span>
      <Link to="/demo" className="font-semibold text-accent-300 hover:text-accent-200">
        View all districts →
      </Link>
    </div>
  </div>
);

export default DemoBanner;
